<template>
    <div class="side-menu"
         role="button"
         tabindex="0"
         :aria-expanded="String(expanded)"
         :aria-label="$i18n.gt('MENU')"
         @click="toggle"
         @keydown.enter.prevent="toggle"
         @keydown.space.prevent="toggle"
         :class="expanded ? 'side-menu-expanded' : ''">
        <template v-if="!expanded">
            <b-icon-chevron-double-right aria-hidden="true"/>
            <p class="menu-text">{{ $i18n.gt('MENU')}}</p>
        </template>

        <div v-if="expanded">
            <b-icon-chevron-double-left aria-hidden="true"/>
            <p class="expanded-menu-text">{{ $i18n.gt('MENU')}}</p>
            <div class="d-flex flex-column">

                <b-btn variant="outline" @click="navigate('/locations')">
                    <span class="icon-mask icon-mask--green" :style="iconMask('house.svg')"></span>
                    {{ $i18n.gt('LOCATIONS_LABEL') }}
                </b-btn>
                <b-btn variant="outline" @click="navigate('/tasks')">
                    <b-icon-card-checklist style="width: 24px;"/>
                    {{ $i18n.gt('TASKS_LABEL') }}
                </b-btn>

                <b-btn variant="success" @click="navigate('/scouts/create')">
                    <span class="icon-mask icon-mask--white" :style="iconMask('clipboard-check.svg')"></span>
                    {{ $i18n.gt('SCOUT_LABEL') }}
                </b-btn>
                <b-btn variant="success" @click="navigate('/applications/create')">
                    <span class="icon-mask icon-mask--white" :style="iconMask('box-arrow-down-right.svg')"></span>
                    {{ $i18n.gt('APPLICATION_LABEL') }}
                </b-btn>

                <b-btn variant="ghost" @click="navigate('/pests')">
                    <span class="icon-mask icon-mask--tan" :style="iconMask('pest.svg')"></span>
                    {{ $i18n.gt('PEST_INSECTS_LABEL') }}
                </b-btn>
                <b-btn variant="ghost" @click="navigate('/beneficials')">
                    <span class="icon-mask icon-mask--tan" :style="iconMask('wasp.svg')"></span>
                    {{ $i18n.gt('BENEFICIALS_LABEL') }}
                </b-btn>
                <b-btn variant="ghost" @click="navigate('/diseases')">
                    <span class="icon-mask icon-mask--tan" :style="iconMask('leaf-eaten.svg')"></span>
                    {{ $i18n.gt('DISEASES_LABEL') }}
                </b-btn>
                <b-btn variant="ghost" @click="navigate('/symptoms')">
                    <span class="icon-mask icon-mask--tan" :style="iconMask('clipboard-pulse.svg')"></span>
                    {{ $i18n.gt('SYMPTOMS_LABEL') }}
                </b-btn>                
                <b-btn variant="ghost" @click="navigate('/pesticides')">
                    <span class="icon-mask icon-mask--tan" :style="iconMask('spray.svg')"></span>
                    {{ $i18n.gt('PESTICIDES_LABEL') }}
                </b-btn>
                <b-btn variant="ghost" @click="navigate('/interactions')" class="small-es">
                    <span class="icon-mask icon-mask--tan" :style="iconMask('spray.svg')"></span>
                    {{ $i18n.gt('PESTICIDE_INTERACTIONS_LABEL') }}
                </b-btn>
                
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NavBar',
    data() {
        return {
            expanded: false,
        }
    },
    computed: {

    },
    methods: {
        toggle() {
            this.expanded = !this.expanded
        },
        navigate(route) {
            this.$router.push(route)
        },
        iconMask(path) {
            const url = require(`../../assets/icons/${path}`)
            return {
                maskImage: `url(${url})`,
                webkitMaskImage: `url(${url})`
            }
        },
    }
}

</script>

<style lang="scss">

@import "/sass/variables_mixins.scss";

div.side-menu.side-menu-expanded .btn,.expanded-menu-text  {
    animation-duration: 1s;
    animation-name: slidein;
}

@keyframes slidein {
    from {
        //margin-left: -100%;
        transform:translateX(-200%);
    }

    to {
        //margin-left: 0%;
        transform:translateX(0%);
    }
}

div.side-menu {
    cursor: pointer;
    position: absolute;
    z-index: 2;
    top:60px;
    left: 0;
    margin-top: 3em;
    padding-bottom: 20px;
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 0px 10px 10px 0px ;
    border-top: 4px solid $neutral-light;
    border-bottom: 4px solid $neutral-light;
    border-right: 4px solid $neutral-light;
    //background:$light-green;
    background: #fff;
    width: 50px;
    transition: all .3s ease-in-out;
    height:560px;
    max-height:560px;

    &:not(.side-menu-expanded):hover {
        /*
        top:80px;
        padding-top:30px;
        padding-bottom:30px;
        height:600px;
        max-height:600px;
        */
         .menu-text {
             letter-spacing: 2px;
         }
    }


    &.side-menu-expanded {
        //transition-delay:.5s;
        width: 250px;
        justify-content: space-between;
        .expanded-menu-text {
            //margin-top: 1em;
            color: darken($green,10%);
            text-align: center;
            font-size: 24px;
            line-height: 1;
            font-weight: 400;
        }
        .bi-chevron-double-left {
            position: absolute;
            right: 1rem;
            top: 1.5rem;
            align-content: center;
            width: 20px;
            height: 20px;
            color: darken($green,10%);
        }
        button.btn {
            &:not(:first-child) {
                margin-top: .5em;
            }
        }
    }

    .bi-chevron-double-right {
        position: absolute;
        top: 1.5em;
        align-content: center;
        width: 20px;
        height: 20px;
        flex-shrink: 0;
        color: #076A1A;
    }
    .menu-text {
        display: flex;
        height: 90%;
        justify-content: center;
        writing-mode: vertical-rl;
        color: darken($green,10%);
        text-align: center;
        font-size: 21px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        transition: all .3s;
    }
    .btn {
        padding:5px 10px;
        display: flex;
        align-items: center;
        gap:.5rem;
    }
    .bi-card-checklist {
        color: #076A1A;
    }
}

.icon-mask {
    display: inline-block;
    width: 24px;
    height: 24px;
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-size: contain;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    flex-shrink: 0;

    &--green {
        background-color: #076A1A;
    }

    &--white {
        background-color: #fff;
    }
}

@media (max-width: 767px) {
    div.side-menu{display:none;}
}

</style>
